import { BackdropProps } from 'donate/platform/platform_donations_29/types'
import React, { useState, useCallback, useMemo } from 'react'
import { FilterSelectionProps, ClosedProductListProps, BaseItem } from './types'

export const FilterSelection = <T extends BaseItem>(props: FilterSelectionProps<T>): JSX.Element => {
  const items: Array<T> = JSON.parse(props.items)
  const secondaryItems: Array<T> = JSON.parse(props.secondaryItems)
  const showSecondary = secondaryItems && secondaryItems.length > 0
  /** @type {T | undefined} */
  const activeItem: T | undefined = items.find((item) => item.title === props.title)
  // TODO items.includes(activeItem) will always return true if activeItem is truthy, but this logic makes little sense in the context of the var names
  // const activeItemIsSecondaryItem = !items.find(activeItem)
  const activeItemIsSecondaryItem = !activeItem

  const [showDropdownContent, setShowDropdownContent] = useState(false)
  // const refFilterSelection = useRef(null)
  const handleClick: (item: T) => void = useMemo(
    () =>
      props.onClick ||
      ((item) => {
        window.location.href = item.url
      }),
    [props.onClick]
  )

  return (
    <div className="module-filter-selection">
      {showDropdownContent && <Backdrop setShowDropdownContent={setShowDropdownContent} />}
      <button className="module-filter-selection__toggle" onClick={() => setShowDropdownContent(!showDropdownContent)}>
        {props.title}
      </button>
      {showDropdownContent && (
        <ul className="module-filter-selection__content mt-1">
          {items.map((item, index) => (
            <li
              className={`module-filter-selection__item p-2 ${item === activeItem && 'font-bold'}`}
              key={index}
              onClick={() => handleClick(item)}
            >
              {item.title}
            </li>
          ))}
          {showSecondary && (
            <ClosedProductList activeItemIsSecondaryItem={activeItemIsSecondaryItem}>
              {secondaryItems.map((item, index) => (
                <li
                  className={`module-filter-selection__item p-2 ${item.title === props.title && 'font-bold'}`}
                  key={index}
                  onClick={() => handleClick(item)}
                >
                  {item.title}
                </li>
              ))}
            </ClosedProductList>
          )}
        </ul>
      )}
    </div>
  )
}

const ClosedProductList = (props: ClosedProductListProps): JSX.Element => {
  const [showClosedProducts, setShowClosedProducts] = useState(props.activeItemIsSecondaryItem)
  const toggle: React.MouseEventHandler<HTMLButtonElement> = useCallback(() => setShowClosedProducts((old) => !old), [])
  return (
    <div>
      <button className="simulated-link p-2 cursor-pointer" onClick={toggle}>
        {!showClosedProducts
          ? I18n.t('modules.filter_selection.show_closed_projects')
          : I18n.t('modules.filter_selection.hide_closed_projects')}
      </button>
      {showClosedProducts && props.children}
    </div>
  )
}

const Backdrop = ({ setShowDropdownContent }: BackdropProps): JSX.Element => {
  const style: React.CSSProperties = {
    backgroundColor: 'black',
    opacity: 0.1,
    position: 'fixed',
    zIndex: 999997,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    outline: 0,
    transition: 'opacity 0.15s linear',
  }
  const onClick = useCallback(() => setShowDropdownContent(false), [setShowDropdownContent])
  return <div style={style} onClick={onClick} />
}
